/**
 * @generated SignedSource<<5e6e1c9d0acaa578e9bb916078aa6533>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UnlockedEvent$data = {
  readonly actor: {
    readonly " $fragmentSpreads": FragmentRefs<"TimelineRowEventActor">;
  } | null;
  readonly createdAt: string;
  readonly databaseId: number | null;
  readonly " $fragmentType": "UnlockedEvent";
};
export type UnlockedEvent$key = {
  readonly " $data"?: UnlockedEvent$data;
  readonly " $fragmentSpreads": FragmentRefs<"UnlockedEvent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UnlockedEvent",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "databaseId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "actor",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TimelineRowEventActor"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "UnlockedEvent",
  "abstractKey": null
};

(node as any).hash = "f3f5b5eea0ff51d2508abc2c64f62822";

export default node;
